import { render, staticRenderFns } from "./faceback.vue?vue&type=template&id=4e106f9e&scoped=true"
import script from "./faceback.vue?vue&type=script&lang=js"
export * from "./faceback.vue?vue&type=script&lang=js"
import style0 from "./faceback.vue?vue&type=style&index=0&id=4e106f9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e106f9e",
  null
  
)

export default component.exports